import {formsStore as oldAPIFormsStore} from '../_legacy/Form/stores/FormsStore';
import {isoLangs} from './consts';
import {getGeneralLanguages} from './service';
import {formsStore as newAPIFormStore} from '../stores/Form';

export interface systemLang {
    lang: string;
    langtitle: string;
    googlelang: string;
    sort: string;
}

export function getLangNativeName(googleLang: string) {
    return isoLangs[googleLang] && isoLangs[googleLang].nativeName;
}

export async function fetchSysLangs(useNewStore?: boolean) {
    let langs: systemLang[] = useNewStore
        ? newAPIFormStore.systemLangs
        : oldAPIFormsStore.systemLangs;
    if (!langs || !langs.length) {
        const res: any = await getGeneralLanguages();
        langs = res.General?.[0].Language;

        if (useNewStore) {
            newAPIFormStore.systemLangs = langs;
        } else {
            oldAPIFormsStore.systemLangs = langs;
        }
    }
    return langs;
}

export function getSystemLangs(useNewStore?: boolean) {
    return useNewStore ? newAPIFormStore.systemLangs : oldAPIFormsStore.systemLangs;
}
